<button
  class="button"
  [ngClass]="{ '-open': isOpen }"
  [matMenuTriggerFor]="menu"
  (menuOpened)="isOpen = true"
  (menuClosed)="isOpen = false"
>
  <span>{{ label }}</span>
  <app-icon name="chevron-down"></app-icon>
</button>
<mat-menu #menu="matMenu">
  <div class="menu">
    <div class="item" *ngFor="let item of items; trackBy: trackBy" [ngClass]="{ '-separator': item.separator }">
      <button mat-menu-item (click)="onItemClicked(item)">
        {{ item.title }}
      </button>
    </div>
  </div>
</mat-menu>
